const neutralGrey = {
  '25': '#fcfcfc',
  '50': '#f9f9f9',
  '100': '#f6f6f6',
  '150': '#eeeeee',
  '200': '#e6e6e6',
  '250': '#d9d9d9',
  '300': '#cccccc',
  '350': '#bababa',
  '400': '#a9a9a9',
  '450': '#949494',
  '500': '#7f7f7f',
  '550': '#6a6a6a',
  '600': '#555555',
  '650': '#444444',
  '700': '#323232',
  '750': '#252525',
  '800': '#191919',
  '850': '#111111',
  '900': '#090909',
  '950': '#060606',
  '975': '#030303',
};

export default neutralGrey;
